<ng-container
  *ngIf="{
    entries: entries$ | async,
  } as content"
>
  @if (content.entries?.length) {
    <table class="table-responsive table-md m-t-20 js-table-quotes">
      <thead>
        <tr>
          <th>Catalog #</th>
          <th class="col-part">Part #</th>
          <th class="col-qty">Quote Qty</th>
          <th>Order Frequency</th>
          <th class="col-description">Description</th>
          <th class="col-unit-price">Unit Price</th>
          <th class="col-req-price">Request Price</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let entry of content.entries"
          quote-item
          [entry]="entry"
          [frequencies]="frenquencies"
          (_onChange)="handlerChange($event)"
          (_onRemoveProduct)="handlerRemove($event)"
        ></tr>
      </tbody>
    </table>
  } @else {
    <p class="text-center w-100 ff-bold m-0">{{ 'quotes.noProduct' | cxTranslate }}</p>
  }
</ng-container>
